import view from "../../views/players";
import KTAPI, { getAllPlayers } from "../api/index.api";
import KTDrawer from "../components/drawer";
import { router, toggleLoader } from "../router/index.routes";
import { ioSocket } from "../mm/index.mm";
import { KTLang } from "../lang/lang";
import  langs from "../lang/languages";
import { errorMsg } from "./offscreen.controller";


import { _user, _handler } from "../classes/index.classes";
import { countryCodes } from "../classes/countryCodes";

let skeletonPlayers = /* html */`<tr class="position-relative fs-7" style="background-color: #1b1b1b">
<td class="text-center position-relative z-index-2 ps-4 rounded-start text-nowrap">
    <div class="skeleton-loader-td-player skeleton-loader-td-player-med"></div>
</td>
<td class="position-relative z-index-2">
    <div class="d-flex align-items-center w-100">
        <div class="skeleton-loader-td-player skeleton-loader-td-player-image rounded"></div>
        <div class="ms-4 text-truncate">
            <div class="d-flex align-items-center">
                <div class="skeleton-loader-td-player skeleton-loader-td-player-flag me-2"></div>
                <div class="skeleton-loader-td-player skeleton-loader-td-player-long"></div>
            </div>
        </div>
    </div>
</td>
<td>
    <div class="d-flex align-items-center">
        <div class="skeleton-loader-td-player skeleton-loader-td-player-icon me-5"></div>
        <div class="d-flex justify-content-start flex-column">
            <div class="skeleton-loader-td-player skeleton-loader-td-player-med"></div>
        </div>
    </div>
</td>
<td class="text-center">
    <div class="skeleton-loader-td-player skeleton-loader-td-player-short"></div>
</td>
<td>
    <div class="d-flex align-items-center">
        <div class="skeleton-loader-td-player skeleton-loader-td-player-short"></div>
        <div class="skeleton-loader-td-player skeleton-loader-td-player-short ms-2"></div>
    </div>
</td>
<td>
    <div class="skeleton-loader-td-player skeleton-loader-td-player-med"></div>
</td>
<td>
    <div class="skeleton-loader-td-player skeleton-loader-td-player-med"></div>
</td>
<td>
    <div class="skeleton-loader-td-player skeleton-loader-td-player-med"></div>
</td>
<td>
    <div class="skeleton-loader-td-player skeleton-loader-td-player-med"></div>
</td>
<td class="text-nowrap pe-4 rounded-end">
    <div class="skeleton-loader-td-player skeleton-loader-td-player-med"></div>
</td>
</tr>`;

let noPlayers = /* html */`<tr>
<td colspan="10" class="text-center">
    <div class="text-center">
        <!--begin::Icon-->
        <div class="pt-10 pb-10">
            <i class="fad fa-poll-people fs-4x opacity-50 text-primary"></i>
        </div>
        <!--end::Icon-->

        <!--begin::Message-->
        <div class="pb-15 fw-semibold">
            <h3 class="text-gray-600 fs-5 mb-2" data-i18n="players.no_players_found"></h3>
            <div class="text-muted fs-7" data-i18n="players.no_players_found_desc"></div>
        </div>
        <!--end::Message-->
    </div>
</td>
</tr>`;

var loading = false;
var countryFilter = null;


let pagination = {
    page: null,
    nextPage: null,
    prevPage: null,
    hasNextPage: null,
    hasPrevPage: null,
    limit: null,
    totalDocs: null,
    totalPages: null,
    filters: {},
    loading: false
};


let players = {
    render: () => {        
        return view;
    },
    after_render: async (data) => {

        initFilters();

        $(".table-players-body").empty();
        for (let i = 0; i < 7; i++) {
            $(".table-players-body").append(skeletonPlayers);
        }

        toggleLoader(".table-players-body");
        
        pagination.loading = true;
        
        let res = await KTAPI.getAllPlayers({page: 1, limit: 25});

        if(res.message == 'error') return;

        pagination.page = res.page;
        pagination.nextPage = res.nextPage;
        pagination.prevPage = res.prevPage;
        pagination.hasNextPage = res.hasNextPage;
        pagination.hasPrevPage = res.hasPrevPage;
        pagination.limit = res.limit;
        pagination.totalDocs = res.totalDocs;
        pagination.totalPages = res.totalPages;
        pagination.filters = {};        
        
        $(".table-players-body").empty();
        renderPlayerTable(res);

        pagination.loading = false;        
                
        KTScroll.init();

        

    },
    root: false, 
    rerender: true,
    rendered: false,
    where: '#kt_content',
};

function initFilters()
{
    let placeholder = langs[KTLang.getLang()].translation.players.filter_country_placeholder;
    let countryOptions = [];
    countryOptions.push(`<option></option>`);
    countryOptions.push(`<option value="none">?</option>`);
    countryCodes.codes.map(c => {
        countryOptions.push(`<option value="${c.abbreviation}">${c.country}</option>`);
    });

    $("#rank-filter-country").append(countryOptions);
    //$('#rank-filter-country').val('none').trigger('change');
    if(countryFilter !== null) countryFilter.select2('destroy');
    $('#rank-filter-country').select2({
        placeholder: placeholder,
        allowClear: true,
        closeOnSelect: true,
        width: '100%',
        templateResult: formatCountry,
        templateSelection: formatCountry        
    });

    $('#rank-filter-country').off('select2:select');
    $('#rank-filter-country').on('select2:select', async function (e) {
        let country = e.params.data.id;
        if(country == 'none') country = "";

        
        $(".table-players-body").empty();
        for (let i = 0; i < 7; i++) {
            $(".table-players-body").append(skeletonPlayers);
        }
        toggleLoader(".table-players-body");

        pagination.loading = true;
        pagination.filters = {flag: country};
                
        let res = await KTAPI.getAllPlayers({page: 1, limit: 25, filters: pagination.filters});
        pagination.page = res.page;
        pagination.nextPage = res.nextPage;
        pagination.prevPage = res.prevPage;
        pagination.hasNextPage = res.hasNextPage;
        pagination.hasPrevPage = res.hasPrevPage;
        pagination.limit = res.limit;
        pagination.totalDocs = res.totalDocs;
        pagination.totalPages = res.totalPages;

        $(".table-players-body").empty();
        renderPlayerTable(res);

        pagination.loading = false;
        
    });

    $('#rank-filter-country').off('select2:clear');
    $('#rank-filter-country').on('select2:clear', async function (e) {

        $(this).on("select2:opening", function (ev) {
            ev.preventDefault();
            $(this).off("select2:opening");
        });

        $(".table-players-body").empty();
        for (let i = 0; i < 7; i++) {
            $(".table-players-body").append(skeletonPlayers);
        }
        toggleLoader(".table-players-body");

        pagination.loading = true;
        pagination.filters = {};
        
        let res = await KTAPI.getAllPlayers({page: 1, limit: 25, filters: pagination.filters});
        pagination.page = res.page;
        pagination.nextPage = res.nextPage;
        pagination.prevPage = res.prevPage;
        pagination.hasNextPage = res.hasNextPage;
        pagination.hasPrevPage = res.hasPrevPage;
        pagination.limit = res.limit;
        pagination.totalDocs = res.totalDocs;
        pagination.totalPages = res.totalPages;

        $(".table-players-body").empty();
        renderPlayerTable(res);

        pagination.loading = false;
        
    });
}

function formatCountry (country) {
    if (!country.id || country.id == 'all') { return country.text; }
    var $country = $(
        `<span><img class="me-2" src="assets/media/flags/${country.id == 'none' ? '' : country.id.toLowerCase()}.gif"/>${country.text}</span>`

    );
    return $country;
};

function renderPlayerTable(res)
{
    if(res.docs.length == 0)
    {
        let np = $(noPlayers);
        np.localize();
        $(".table-players-body").append(np);
        return;
    }

    let html = [];    
    if(res.message == 'error') return;
    let pos = 1;
    
    res.docs.map(pl => {
        html.push(renderPlayer(pl));
        pos++;
    });

    $(".table-players-body").append(html);
    router.updatePageLinks();

    function renderPlayer(data)
    {
        let t = /* html */`
            <tr class="position-relative cursor-pointer profile-go text-gray-800 fs-7 ${(res.page-1)*(res.limit)+pos < 4 ? `top-bg-${pos}`:``}" steamid="${data.user.communityid}" style="background-color: #1b1b1b">
                
                <td class="text-center position-relative z-index-2 ps-4 rounded-start text-nowrap">${(res.page-1)*(res.limit)+pos < 4 ? `<i class="fad fa-trophy-alt top-trophy-${(res.page-1)*(res.limit)+pos} fs-1 me-2"></i>`: ''}${(res.page-1)*(res.limit)+pos}.</td>
                <td class="position-relative z-index-2">                                        
                    <div class="d-flex align-items-center w-100">
                        <div class="symbol symbol-35px ${window.isMobile ? '' : 'popover-profile'}" data-steamid="${data.user.steamid}">                            
                            <img src="${data.user.avatar === undefined ? "assets/media/avatars/default.jpg" : data.user.avatar}" class="" alt="">
                        </div>
                        <div class="ms-4 text-truncate">
                            <a href="user/${data.user.communityid}" data-navigo class="d-flex align-items-center fw-bold text-gray-800 text-hover-white">
                            <img class="me-2 pflag" height="12" width="18" src="assets/media/flags/${data.user.countrycode.toLowerCase()}.gif" data-toggle="tooltip" title="${data.user.city} ${data.user.country}"><span class="pl-nick text-truncate" style="min-width:0;"></span>
                            </a>
                        </div>
                        
                        <!--<div class="d-flex justify-content-start flex-column">
                            <div class="d-flex align-items-center"> <img class="me-2" src="assets/media/flags/${data.user.countrycode !== undefined ? data.user.countrycode.toLowerCase() : data.flag.toLowerCase()}.gif"/> <a href="user/${data.user.communityid}" data-navigo class="text-dark fw-bold text-hover-primary mb-1 fs-6 pl-nick"></a></div>                            
                        </div>-->
                    </div>
                </td>
                <td>                    
                    <div class="d-flex align-items-center">
                        <div class="symbol symbol-30px me-5 rounded overflow-hidden">
                            <span class="symbol-label bg-transparent">
                                <img src="assets/media/ranks/rank_${getEloLevel(data.rating, data.rd)}.png" class="h-100 align-self-center" alt="">
                            </span>
                        </div>
                        
                        <div class="d-flex justify-content-start flex-column">
                            <span class="text-dark fw-bold">${data.rating}</span>                                    
                        </div>
                    </div>
                </td>
                <td class="text-center">${data.matches}</td>
                <td>${data.matches_win} (<span class="text-success">${Math.round(data.matches_win/(data.matches == 0 ? 1 : data.matches)*100, 2)}%</span>)</td>                
                <td>${(data.damage/(data.rounds == 0 ? 1 : data.rounds)).toFixed(2)}</td>
                <td>${(data.kills/(data.deaths == 0 ? 1 : data.deaths)).toFixed(2)}</td>                
                <td>${data.kills}</td>
                <td>${data.deaths}</td>
                <td class="text-nowrap pe-4 rounded-end"> ${data.hs} / ${Math.round(data.hs/(data.kills == 0 ? 1 : data.kills)*100,2)}%</td>
                <!--<td class="text-success">${Math.round(data.matches_win/(data.matches == 0 ? 1 : data.matches)*100, 2)}%</td>-->
                <!--<td class="text-danger pe-4 text-end rounded-end">${Math.round(data.matches_lose/(data.matches == 0 ? 1 : data.matches)*100, 2)}%</td>-->
                
            </tr>            
        `;

        t = $(t);
        t.find(".pflag").tooltip();        
        t.find(".pl-nick").text(data.user.nickname !== undefined ? data.user.nickname : data.last_nick);

        return t;
    }
}


$(document).ready(function(){

    $(window).scroll(async function() {
        if(router.getCurrentLocation().url.includes("players"))
        {
            if ($(window).scrollTop() >= $(document).height() - $(window).height() - 100 && !pagination.loading && pagination.hasNextPage) {
                pagination.loading = true;
                
                let res = await KTAPI.getAllPlayers({page: pagination.nextPage, limit: pagination.limit, filters: pagination.filters});

                if(res.message == 'error') return;

                pagination.page = res.page;
                pagination.nextPage = res.nextPage;
                pagination.prevPage = res.prevPage;
                pagination.hasNextPage = res.hasNextPage;
                pagination.hasPrevPage = res.hasPrevPage;
                pagination.limit = res.limit;
                pagination.totalDocs = res.totalDocs;
                pagination.totalPages = res.totalPages;

                renderPlayerTable(res);
                
                pagination.loading = false;
                
            }
        }
    });    
    
});


const getEloLevel = (rate, rd) => {
    if(rd == 100) return 0;
    if(rate > 0 && rate < 801)
    {
        return 1;
    }
    if(rate > 800 && rate < 951)
    {
        return 2;
    }
    if(rate > 950 && rate < 1101)
    {
        return 3;
    }
    if(rate > 1100 && rate < 1251)
    {
        return 4;
    }
    if(rate > 1250 && rate < 1401)
    {
        return 5;
    }
    if(rate > 1400 && rate < 1551)
    {
        return 6;
    }
    if(rate > 1550 && rate < 1701)
    {
        return 7;
    }
    if(rate > 1700 && rate < 1851)
    {
        return 8;
    }
    if(rate > 1850 && rate < 2001)
    {
        return 9;
    }
    if(rate > 2000)
    {
        return 10;
    }
};



export default players;